import pick from 'lodash/pick'
import { FormModel, PosFields } from './index'

import * as BonusPoints from './BonusPoints'
import * as BuyItemGetDollarOffItem from './BuyItemGetDollarOffItem'
import * as BuyItemGetPercentOffItem from './BuyItemGetPercentOffItem'
import * as BuyOneGetFreeOne from './BuyOneGetFreeOne'
import * as BuyXGetDollarOffPurchase from './BuyXGetDollarOffPurchase'
import * as BuyXGetPercentOffPurchase from './BuyXGetPercentOffPurchase'
import * as DeliveryDiscount from './DeliveryDiscount'
import * as DollarOffItem from './DollarOffItem'
import * as DollarOffPurchase from './DollarOffPurchase'
import * as FixedPrice from './FixedPrice'
import * as FreeItem from './FreeItem'
import * as FreeModifier from './FreeModifier'
import * as GoldenTicket from './GoldenTicket'
import * as HiddenMenu from './HiddenMenu'
import * as PercentOffItem from './PercentOffItem'
import * as PercentOffPurchase from './PercentOffPurchase'

type FormModelKeys = {
  getFormModelKeys(): (keyof FormModel)[]
  getPosFieldKeys?(): (keyof PosFields)[]
}

export function castFormModel(formModel: FormModel): FormModel {
  const typeKey = formModel.typeItem?.key

  switch (typeKey) {
    case 'get_a_free_item':
      return cast(formModel, FreeItem)
    case 'get_a_free_modifier':
      return cast(formModel, FreeModifier)
    case 'get_%_off_purchase':
      return cast(formModel, PercentOffPurchase)
    case 'get_%_off_item':
      return cast(formModel, PercentOffItem)
    case 'get_$_off_purchase':
      return cast(formModel, DollarOffPurchase)
    case 'get_$_off_item':
      return cast(formModel, DollarOffItem)
    case 'buy_x_get_%_off_purchase':
      return cast(formModel, BuyXGetPercentOffPurchase)
    case 'buy_item_get_%_off_item':
      return cast(formModel, BuyItemGetPercentOffItem)
    case 'buy_x_get_$_off_purchase':
      return cast(formModel, BuyXGetDollarOffPurchase)
    case 'buy_item_get_$_off_item':
      return cast(formModel, BuyItemGetDollarOffItem)
    case 'any_item_for_$x':
    case 'any_modifier_for_$x':
    case 'free_fixed_price_item':
      return cast(formModel, FixedPrice)
    case 'delivery_discount':
      return cast(formModel, DeliveryDiscount)
    case 'buy_one_get_free_one':
      return cast(formModel, BuyOneGetFreeOne)
    case 'hidden_menu':
      return cast(formModel, HiddenMenu)
    case 'golden_ticket':
      return cast(formModel, GoldenTicket)
    case 'bonus_points':
      return cast(formModel, BonusPoints)
    default:
      return formModel
  }
}

function cast(model: FormModel, keys: FormModelKeys): FormModel {
  const baseModel = pick(model, keys.getFormModelKeys()) as FormModel

  if (!keys.getPosFieldKeys) {
    return baseModel
  }

  return {
    ...baseModel,
    posFields: filterPosFields(model.posFields, keys.getPosFieldKeys()),
  }
}

function filterPosFields(
  posFields: Record<string, PosFields>,
  allowedKeys: (keyof PosFields)[]
): Record<string, PosFields> {
  const filteredPosFields: Record<string, PosFields> = {}

  Object.keys(posFields).forEach(providerKey => {
    filteredPosFields[providerKey] = pick(
      posFields[providerKey],
      allowedKeys
    ) as PosFields
  })

  return filteredPosFields
}
